import React from 'react';
import ListItemText from '@mui/material/ListItemText';
import { SystemRecordTypeEnum } from '../../record-viewer/types';
import RecordKeyDates from '../../record-viewer/record-key-dates';

interface Props {
  task: Record<string, any>,
}

const RECORD_TASK_TITLE = '4ae3';
const RECORD_TASK_DUE_DATE = '0ed3';

const TaskPickerItem: React.FC<Props> = ({
  task,
}) => {
  const { [RECORD_TASK_DUE_DATE]: dueDate, [RECORD_TASK_TITLE]: title } = task.form_values;
  const systemRecordType = SystemRecordTypeEnum.Tasks;
  return (
    <ListItemText
      disableTypography
      primary={title}
      secondary={(
        <RecordKeyDates
          dueOn={dueDate}
          systemRecordType={systemRecordType}
        />
      )}
    />
  );
};

export default TaskPickerItem;
